// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__YkYW9","headerCard":"Layout_headerCard__JOsij","mainCard":"Layout_mainCard__wUwN+"};